export interface MangaChapter {
  slug: string;
  title: string;
  number: number;
  updateDate: string;
  pages: number;
}

export interface Manga {
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  categorySlug: string;
  status: '连载中' | '已完结';
  rating: number;
  totalChapters: number;
  views: number;
  tags: string[];
  chapters: MangaChapter[];
  updateDate: string;
  featured: boolean;
}

export interface Category {
  name: string;
  slug: string;
  description: string;
  count: number;
}

export const categories: Category[] = [
  { name: '全部漫画', slug: 'all', description: '浏览全部刃牙系列漫画及相关格斗漫画作品', count: 12 },
  { name: '格斗漫画', slug: 'fighting', description: '热血格斗题材漫画，拳拳到肉的激烈对决', count: 6 },
  { name: '热血漫画', slug: 'hot-blooded', description: '充满激情与热血的高燃漫画作品', count: 5 },
  { name: '经典名作', slug: 'classic', description: '经久不衰的经典漫画名作，值得反复阅读', count: 4 },
  { name: '最新上架', slug: 'latest', description: '最新上架的漫画作品，紧跟更新节奏', count: 8 },
];

export const mangas: Manga[] = [
  {
    slug: 'baki-the-grappler',
    title: '刃牙',
    author: '板垣恵介',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20art%20style%20featuring%20a%20muscular%20fighter%20with%20intense%20expression%20and%20scarred%20face%2C%20dramatic%20lighting%2C%20bold%20typography%2C%20vintage%2090s%20aesthetic%2C%20warm%20sepia%20tones%20with%20dark%20shadows%2C%20clean%20minimal%20background%2C%20action%20pose%2C%20manga%20cover%20layout&width=600&height=850&seq=baki-grappler-cover&orientation=portrait',
    description: '《刃牙》是日本漫画家板垣恵介创作的格斗漫画系列的第一部作品。故事围绕主角範馬刃牙展开，他为了超越被称为"地上最强生物"的父亲範馬勇次郎而不断挑战各路强者的热血格斗故事。作品以夸张的肌肉线条、激烈的格斗场面和独特的战斗哲学著称，是全球格斗漫画的经典代表作。',
    category: '格斗漫画',
    categorySlug: 'fighting',
    status: '已完结',
    rating: 4.8,
    totalChapters: 42,
    views: 2580000,
    tags: ['格斗', '热血', '经典', '範馬刃牙', '父子对决'],
    updateDate: '2024-03-15',
    featured: true,
    chapters: [
      { slug: 'baki-the-grappler-1', title: '第1话 地上最强的少年', number: 1, updateDate: '2024-03-15', pages: 45 },
      { slug: 'baki-the-grappler-2', title: '第2话 挑战者', number: 2, updateDate: '2024-03-12', pages: 42 },
      { slug: 'baki-the-grappler-3', title: '第3话 地下竞技场', number: 3, updateDate: '2024-03-10', pages: 40 },
      { slug: 'baki-the-grappler-4', title: '第4话 鬼面', number: 4, updateDate: '2024-03-08', pages: 43 },
      { slug: 'baki-the-grappler-5', title: '第5话 战士的觉悟', number: 5, updateDate: '2024-03-05', pages: 41 },
      { slug: 'baki-the-grappler-6', title: '第6话 父亲的影子', number: 6, updateDate: '2024-03-01', pages: 44 },
    ],
  },
  {
    slug: 'baki-ii',
    title: '刃牙II',
    author: '板垣恵介',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20art%20showing%20a%20powerful%20warrior%20in%20dynamic%20fighting%20stance%2C%20ripped%20muscles%2C%20sweat%20and%20blood%2C%20dark%20arena%20background%2C%20dramatic%20contrast%20lighting%2C%20bold%20red%20and%20black%20color%20scheme%2C%20intense%20atmosphere%2C%20manga%20cover%20format&width=600&height=850&seq=baki-ii-cover&orientation=portrait',
    description: '《刃牙II》是刃牙系列的第二部作品。在经历了地下竞技场的历练后，刃牙面临更强大的对手。死囚篇中五位世界级死刑犯齐聚东京，掀起一场生死之战。中国大擂台篇更将舞台搬到了中国，刃牙与各路武术高手展开巅峰对决。本作扩展了刃牙的世界观，引入了更多格斗流派和传奇武者。',
    category: '格斗漫画',
    categorySlug: 'fighting',
    status: '已完结',
    rating: 4.9,
    totalChapters: 31,
    views: 2130000,
    tags: ['格斗', '热血', '死囚篇', '中国大擂台', '经典'],
    updateDate: '2024-02-28',
    featured: true,
    chapters: [
      { slug: 'baki-ii-1', title: '第1话 新的开始', number: 1, updateDate: '2024-02-28', pages: 42 },
      { slug: 'baki-ii-2', title: '第2话 死囚降临', number: 2, updateDate: '2024-02-25', pages: 44 },
      { slug: 'baki-ii-3', title: '第3话 各自的战斗', number: 3, updateDate: '2024-02-20', pages: 40 },
      { slug: 'baki-ii-4', title: '第4话 野兽的嗅觉', number: 4, updateDate: '2024-02-18', pages: 43 },
    ],
  },
  {
    slug: 'hanma-baki',
    title: '範馬刃牙',
    author: '板垣恵介',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20manga%20cover%20illustration%20of%20a%20legendary%20fighter%20with%20demon%20back%20muscle%20formation%2C%20extreme%20muscular%20definition%2C%20fierce%20battle%20expression%2C%20dark%20atmosphere%20with%20crimson%20accents%2C%20powerful%20composition%2C%20manga%20style%20with%20bold%20linework&width=600&height=850&seq=hanma-baki-cover&orientation=portrait',
    description: '《範馬刃牙》是刃牙系列的第三部作品。故事进入了最高潮——刃牙与父亲勇次郎之间的终极对决。这部作品中深入探讨了範馬一族的血脉之谜，刃牙在与原始人皮可、巨象等超规格对手的战斗中不断突破极限，最终迎来了与"地上最强生物"範馬勇次郎的父子之战。',
    category: '格斗漫画',
    categorySlug: 'fighting',
    status: '已完结',
    rating: 4.9,
    totalChapters: 37,
    views: 1960000,
    tags: ['格斗', '範馬刃牙', '勇次郎', '皮可', '父子之战'],
    updateDate: '2024-01-20',
    featured: true,
    chapters: [
      { slug: 'hanma-baki-1', title: '第1话 最强之名', number: 1, updateDate: '2024-01-20', pages: 41 },
      { slug: 'hanma-baki-2', title: '第2话 皮可出现', number: 2, updateDate: '2024-01-18', pages: 43 },
      { slug: 'hanma-baki-3', title: '第3话 原始之力', number: 3, updateDate: '2024-01-15', pages: 45 },
      { slug: 'hanma-baki-4', title: '第4话 鬼的咆哮', number: 4, updateDate: '2024-01-12', pages: 42 },
    ],
  },
  {
    slug: 'baki-dou',
    title: '刃牙道',
    author: '板垣恵介',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20manga%20cover%20featuring%20a%20samurai%20spirit%20warrior%20with%20ancient%20and%20modern%20clash%20theme%2C%20Miyamoto%20Musashi%20reborn%2C%20sword%20and%20fist%20contrast%2C%20clean%20sharp%20art%20style%2C%20silver%20and%20dark%20red%20tones%2C%20manga%20cover%20layout&width=600&height=850&seq=baki-dou-cover&orientation=portrait',
    description: '《刃牙道》是刃牙系列的第四部作品。本作最大的看点是——宫本武藏被现代科技复活！这位日本史上最强的剑豪来到现代社会，与当代格斗家们展开了一系列惊心动魄的对决。剑与拳的碰撞，古与今的交锋，将刃牙的世界推向了全新的维度。',
    category: '格斗漫画',
    categorySlug: 'fighting',
    status: '已完结',
    rating: 4.7,
    totalChapters: 22,
    views: 1520000,
    tags: ['格斗', '宫本武藏', '刀剑', '古今对决', '复活'],
    updateDate: '2024-01-05',
    featured: false,
    chapters: [
      { slug: 'baki-dou-1', title: '第1话 剑圣复活', number: 1, updateDate: '2024-01-05', pages: 44 },
      { slug: 'baki-dou-2', title: '第2话 天下无双', number: 2, updateDate: '2024-01-02', pages: 42 },
      { slug: 'baki-dou-3', title: '第3话 剑与拳', number: 3, updateDate: '2023-12-28', pages: 43 },
    ],
  },
  {
    slug: 'baki-dou-ii',
    title: '刃牙道II',
    author: '板垣恵介',
    coverImage: 'https://readdy.ai/api/search-image?query=Premium%20manga%20cover%20art%20showing%20a%20giant%20sumo%20wrestler%20facing%20off%20against%20a%20lean%20fighter%2C%20sumo%20dohyo%20setting%2C%20intense%20staredown%2C%20traditional%20Japanese%20elements%20blended%20with%20modern%20style%2C%20bold%20composition%2C%20manga%20cover&width=600&height=850&seq=baki-dou-ii-cover&orientation=portrait',
    description: '《刃牙道II》是刃牙系列的最新篇章，也是目前正在连载的作品。本作以相扑为主题，传说中的相扑之神"野见宿禰"的后裔登场，向现代格斗界发起挑战。刃牙和伙伴们将与传承千年的相扑之力展开前所未有的激烈对决。',
    category: '格斗漫画',
    categorySlug: 'fighting',
    status: '连载中',
    rating: 4.6,
    totalChapters: 18,
    views: 980000,
    tags: ['格斗', '相扑', '野见宿禰', '连载中', '最新'],
    updateDate: '2024-06-01',
    featured: true,
    chapters: [
      { slug: 'baki-dou-ii-1', title: '第1话 宿禰降临', number: 1, updateDate: '2024-06-01', pages: 42 },
      { slug: 'baki-dou-ii-2', title: '第2话 相扑之道', number: 2, updateDate: '2024-05-28', pages: 40 },
      { slug: 'baki-dou-ii-3', title: '第3话 千年之力', number: 3, updateDate: '2024-05-25', pages: 43 },
    ],
  },
  {
    slug: 'baki-gaiden-scarface',
    title: '刃牙外传：伤疤',
    author: '板垣恵介',
    coverImage: 'https://readdy.ai/api/search-image?query=Manga%20cover%20illustration%20of%20a%20scarred%20warrior%20with%20intense%20eyes%2C%20back%20alley%20setting%2C%20dark%20and%20gritty%20atmosphere%2C%20rainy%20night%20scene%2C%20blood%20and%20sweat%20details%2C%20manga%20style%20with%20heavy%20shadows%2C%20noir%20vibe&width=600&height=850&seq=baki-gaiden-cover&orientation=portrait',
    description: '《刃牙外传：伤疤》是刃牙系列的官方外传作品。以花山薫为主角，讲述这位被称为"侠客"的男人背后的故事。从他的童年经历到成为极道最强传说的过程，展现了一个与主线不同视角的刃牙世界。',
    category: '热血漫画',
    categorySlug: 'hot-blooded',
    status: '已完结',
    rating: 4.5,
    totalChapters: 12,
    views: 780000,
    tags: ['外传', '花山薫', '极道', '侠客', '热血'],
    updateDate: '2023-11-20',
    featured: false,
    chapters: [
      { slug: 'baki-gaiden-1', title: '第1话 侠客之名', number: 1, updateDate: '2023-11-20', pages: 40 },
      { slug: 'baki-gaiden-2', title: '第2话 幼年的誓言', number: 2, updateDate: '2023-11-15', pages: 42 },
    ],
  },
  {
    slug: 'garouden',
    title: '饿狼传',
    author: '板垣恵介 / 夢枕獏',
    coverImage: 'https://readdy.ai/api/search-image?query=Manga%20cover%20art%20featuring%20a%20lone%20wolf%20fighter%20in%20dark%20alley%2C%20street%20fighting%20aesthetic%2C%20raw%20power%20and%20brutal%20style%2C%20monochrome%20with%20red%20accents%2C%20gritty%20realistic%20art%20style%2C%20manga%20cover%20format&width=600&height=850&seq=garouden-cover&orientation=portrait',
    description: '《饿狼传》是板垣恵介与小说家夢枕獏合作的格斗漫画作品。故事以丹波文七为主角，讲述他在街头格斗世界中不断挑战各路强者的故事。与刃牙系列不同，《饿狼传》更加写实，格斗风格更加残酷直接。',
    category: '格斗漫画',
    categorySlug: 'fighting',
    status: '已完结',
    rating: 4.4,
    totalChapters: 28,
    views: 650000,
    tags: ['格斗', '街头', '写实', '餓狼', '丹波文七'],
    updateDate: '2023-09-10',
    featured: false,
    chapters: [
      { slug: 'garouden-1', title: '第1话 餓狼', number: 1, updateDate: '2023-09-10', pages: 41 },
      { slug: 'garouden-2', title: '第2话 街头之王', number: 2, updateDate: '2023-09-05', pages: 43 },
    ],
  },
  {
    slug: 'kengan-ashura',
    title: '拳愿阿修罗',
    author: 'サンドロビッチ・ヤバ子 / だろめおん',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20manga%20cover%20showing%20a%20businessman%20turned%20fighter%20in%20corporate%20arena%2C%20suit%20and%20muscles%20contrast%2C%20underground%20fighting%20tournament%20theme%2C%20sleek%20art%20style%2C%20dark%20blue%20and%20silver%20tones%2C%20manga%20cover&width=600&height=850&seq=kengan-ashura-cover&orientation=portrait',
    description: '《拳愿阿修罗》是一部风格独特的格斗漫画。故事设定在日本经济界的暗面——企业间通过雇佣斗士在地下竞技场进行"拳愿比赛"来解决商业纠纷。主角十鬼蛇王马代表山下商事参加拳愿绝命淘汰赛，与各路强敌展开殊死搏斗。',
    category: '热血漫画',
    categorySlug: 'hot-blooded',
    status: '已完结',
    rating: 4.7,
    totalChapters: 27,
    views: 1230000,
    tags: ['格斗', '商业', '地下竞技', '淘汰赛', '热血'],
    updateDate: '2023-08-15',
    featured: false,
    chapters: [
      { slug: 'kengan-ashura-1', title: '第1话 拳愿', number: 1, updateDate: '2023-08-15', pages: 45 },
      { slug: 'kengan-ashura-2', title: '第2话 阿修罗', number: 2, updateDate: '2023-08-10', pages: 42 },
    ],
  },
  {
    slug: 'hajime-no-ippo',
    title: '第一神拳',
    author: '森川ジョージ',
    coverImage: 'https://readdy.ai/api/search-image?query=Classic%20manga%20cover%20of%20a%20young%20boxer%20with%20determined%20expression%2C%20boxing%20gloves%2C%20gym%20background%2C%20shonen%20fighting%20spirit%2C%20warm%20yellow%20and%20brown%20tones%2C%20inspirational%20composition%2C%20manga%20cover&width=600&height=850&seq=hajime-ippo-cover&orientation=portrait',
    description: '《第一神拳》是森川ジョージ创作的经典拳击漫画。故事讲述高中生幕之内一步从被欺凌的弱者成长为职业拳击手的励志故事。虽然没有刃牙那样夸张的肌肉表现，但拳拳到肉的真实感和角色成长曲线深深打动了无数读者。',
    category: '经典名作',
    categorySlug: 'classic',
    status: '连载中',
    rating: 4.8,
    totalChapters: 143,
    views: 3100000,
    tags: ['拳击', '励志', '经典', '幕之内一步', '体育'],
    updateDate: '2024-05-20',
    featured: false,
    chapters: [
      { slug: 'hajime-ippo-1', title: '第1话 第一步', number: 1, updateDate: '2024-05-20', pages: 40 },
      { slug: 'hajime-ippo-2', title: '第2话 冲击', number: 2, updateDate: '2024-05-18', pages: 42 },
    ],
  },
  {
    slug: 'tough',
    title: '滩神影流',
    author: '猿渡哲也',
    coverImage: 'https://readdy.ai/api/search-image?query=Manga%20cover%20featuring%20a%20martial%20arts%20master%20in%20traditional%20dojo%2C%20ancient%20fighting%20technique%20theme%2C%20bloodline%20and%20inheritance%2C%20intense%20training%20scene%2C%20traditional%20Japanese%20aesthetic%2C%20manga%20cover&width=600&height=850&seq=tough-cover&orientation=portrait',
    description: '《滩神影流》是猿渡哲也创作的格斗漫画。讲述了滩神影流古武术的继承者们之间的激烈对决。作品融合了传统武术与现代格斗，以灘神影流这一虚构的古武术流派为核心，展开一系列惊心动魄的战斗。',
    category: '经典名作',
    categorySlug: 'classic',
    status: '已完结',
    rating: 4.3,
    totalChapters: 38,
    views: 520000,
    tags: ['古武术', '格斗', '流派', '继承', '经典'],
    updateDate: '2023-06-30',
    featured: false,
    chapters: [
      { slug: 'tough-1', title: '第1话 神影', number: 1, updateDate: '2023-06-30', pages: 41 },
      { slug: 'tough-2', title: '第2话 秘传', number: 2, updateDate: '2023-06-25', pages: 40 },
    ],
  },
  {
    slug: 'shigurui',
    title: '死狂',
    author: '山口贵由',
    coverImage: 'https://readdy.ai/api/search-image?query=Manga%20cover%20of%20two%20samurai%20facing%20each%20other%20with%20swords%2C%20edo%20period%20setting%2C%20death%20and%20honor%20theme%2C%20dark%20and%20elegant%20composition%2C%20blood%20splatter%20details%2C%20traditional%20Japanese%20art%20influence%2C%20manga%20cover&width=600&height=850&seq=shigurui-cover&orientation=portrait',
    description: '《死狂》是山口贵由创作的剑道格斗漫画，被誉为"刃牙的剑道版"。作品以江户时代为背景，讲述了岩本虎眼流剑术道场的残酷继承之战。极致的暴力美学与独特的生死观，使这部作品成为了另类格斗漫画的经典。',
    category: '经典名作',
    categorySlug: 'classic',
    status: '已完结',
    rating: 4.6,
    totalChapters: 15,
    views: 420000,
    tags: ['剑道', '江户', '暴力美学', '经典', '武士'],
    updateDate: '2023-04-15',
    featured: false,
    chapters: [
      { slug: 'shigurui-1', title: '第1话 死狂', number: 1, updateDate: '2023-04-15', pages: 44 },
      { slug: 'shigurui-2', title: '第2话 虎眼流', number: 2, updateDate: '2023-04-10', pages: 42 },
    ],
  },
  {
    slug: 'rikudou',
    title: '六道',
    author: '松本次郎',
    coverImage: 'https://readdy.ai/api/search-image?query=Manga%20cover%20of%20an%20underground%20fighter%20with%20dark%20past%2C%20prison%20and%20fighting%20theme%2C%20raw%20brutal%20aesthetic%2C%20dark%20grey%20and%20blood%20red%20color%20scheme%2C%20gritty%20and%20realistic%20art%20style%2C%20manga%20cover&width=600&height=850&seq=rikudou-cover&orientation=portrait',
    description: '《六道》是松本次郎创作的暗黑格斗漫画。故事围绕地下拳击与黑道世界展开，主角六道在残酷的地下格斗中寻找生存的意义。作品以黑暗写实的笔触描绘了格斗世界的残酷与人性的挣扎。',
    category: '热血漫画',
    categorySlug: 'hot-blooded',
    status: '已完结',
    rating: 4.2,
    totalChapters: 20,
    views: 380000,
    tags: ['地下格斗', '黑暗', '拳击', '黑道', '写实'],
    updateDate: '2023-02-28',
    featured: false,
    chapters: [
      { slug: 'rikudou-1', title: '第1话 地狱之门', number: 1, updateDate: '2023-02-28', pages: 40 },
      { slug: 'rikudou-2', title: '第2话 野兽', number: 2, updateDate: '2023-02-25', pages: 42 },
    ],
  },
];

export const faqs = [
  {
    question: '刃牙漫画可以在线免费观看吗？',
    answer: '是的，本站提供刃牙漫画全集免费在线阅读服务。包括《刃牙》《刃牙II》《範馬刃牙》《刃牙道》《刃牙道II》以及相关外传作品，全部支持下拉式即时观看，无需下载任何软件。',
  },
  {
    question: '刃牙漫画的阅读顺序是什么？',
    answer: '推荐按照出版顺序阅读：1.《刃牙》（第一部）→ 2.《刃牙II》（第二部）→ 3.《範馬刃牙》（第三部）→ 4.《刃牙道》（第四部）→ 5.《刃牙道II》（第五部/连载中）。外传作品可在阅读主线后根据兴趣选择。',
  },
  {
    question: '刃牙漫画的作者是谁？',
    answer: '刃牙系列漫画的作者是日本著名漫画家板垣恵介（いたがき けいすけ）。他于1991年开始在《周刊少年Champion》上连载《刃牙》，至今已创作超过30年。板垣恵介以其独特的肌肉美学和格斗哲学被称为"格斗漫画之神"。',
  },
  {
    question: '刃牙漫画适合什么年龄段观看？',
    answer: '刃牙漫画包含大量的格斗暴力场景，建议16岁以上的读者观看。作品中虽有激烈的战斗描写，但其核心传达的是不屈不挠的精神和对强大的追求，具有深刻的励志意义。',
  },
  {
    question: '刃牙漫画有动画版吗？',
    answer: '有的。刃牙系列已有多部动画改编作品，包括TV动画《刃牙》《刃牙：大擂台赛篇》以及Netflix制作的《範馬刃牙》《刃牙道》等。动画和漫画各具特色，漫画原作在细节和表现力上更加丰富。',
  },
  {
    question: '为什么刃牙被称为格斗漫画的巅峰之作？',
    answer: '刃牙被誉为格斗漫画的巅峰，主要因为：1）开创性地将人体肌肉美学发挥到极致；2）融合了世界各地的格斗技和武术流派；3）深刻的父子羁绊和人性探讨；4）跨越30年的宏大叙事体系；5）影响了一代又一代的漫画家和读者。',
  },
];

export const siteInfo = {
  name: '刃牙漫画在线观看',
  description: '刃牙漫画免费在线阅读平台，提供全集下拉式即时观看体验。刃牙漫画在线看，无需下载，流畅浏览全部章节。汇集刃牙全系列以及相关格斗漫画推荐。',
  established: '2020',
  email: 'contact@baki-manga.com',
  qq: '1234567890',
};